/*
 =================================================
	WARNING: This should only used internally for bit component docs/componsitions
 =================================================
* */
import { createTheme, createThemeGlobalStyles } from '@eclo/mode'
import React, { ReactNode } from 'react'
import { createGlobalStyle, ThemeProvider as StyledThemeProvider } from 'styled-components'
import { themeConfig } from './theme.config'

const theme = createTheme(themeConfig)

const GlobalStyles = createGlobalStyle`
  ${createThemeGlobalStyles(theme)}
	body, html {
		font-size: 12px;
		letter-spacing: 0.5px;
	}
`

export const ThemeProvider = ({ children }: { children?: ReactNode }) => {
	return (
		<StyledThemeProvider theme={theme as any}>
			<GlobalStyles />
			{children}
		</StyledThemeProvider>
	)
}
